import { cdnCommonPath } from "@/constants/cdnUrls";
import Image from "next/image";

function NotFoundState({ title, description }) {
  return (
    <div className="flex w-full flex-col items-center justify-center p-4 text-center md:px-0 md:py-6">
      <Image
        src={`${cdnCommonPath}telescope.svg`}
        alt="Alternatif Tarihler"
        width={60}
        height={60}
      />
      <h2 className="text-foreground mt-3 mb-2 text-lg leading-26 font-semibold">
        {title}
      </h2>
      <p className="text-foreground max-w-full text-sm leading-19 font-normal md:max-w-[350px]">
        {description}
      </p>
    </div>
  );
}

export default NotFoundState;
